"use client";

import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

export function Meteors({
  number = 20,
  className,
}: {
  number?: number;
  className?: string;
}) {
  const [meteorStyles, setMeteorStyles] = useState<
    Array<{ top: string; left: string; animationDelay: string; animationDuration: string }>
  >([]);

  useEffect(() => {
    const styles = Array.from({ length: number }, () => ({
      top: `${Math.random() * 100 - 50}%`,
      left: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 3}s`,
      animationDuration: `${Math.floor(Math.random() * 8 + 2)}s`,
    }));
    setMeteorStyles(styles);
  }, [number]);

  return (
    <>
      {meteorStyles.map((style, idx) => (
        <span
          key={idx}
          className={cn(
            "pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] animate-meteor rounded-[9999px] bg-primary shadow-[0_0_0_1px_#ffffff10]",
            "before:absolute before:top-1/2 before:h-[1px] before:w-[50px] before:-translate-y-1/2 before:bg-gradient-to-r before:from-primary/80 before:to-transparent before:content-['']",
            className
          )}
          style={{
            ...style,
            position: "absolute",
          }}
        />
      ))}
      <style jsx>{`
        @keyframes meteor {
          0% {
            transform: rotate(215deg) translateX(0);
            opacity: 1;
          }
          70% {
            opacity: 1;
          }
          100% {
            transform: rotate(215deg) translateX(-500px);
            opacity: 0;
          }
        }
        .animate-meteor {
          animation: meteor var(--duration, 5s) linear infinite;
          animation-delay: var(--delay, 0s);
        }
      `}</style>
    </>
  );
}
